import { render } from "./ContentPagePopup.vue?vue&type=template&id=0903b2fc"
import script from "./ContentPagePopup.vue?vue&type=script&lang=js"
export * from "./ContentPagePopup.vue?vue&type=script&lang=js"

import "./ContentPagePopup.vue?vue&type=style&index=0&id=0903b2fc&lang=css"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\state-of-green-value-chains\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__